import { render, staticRenderFns } from "./Submenu.vue?vue&type=template&id=16e91700&functional=true"
var script = {}
import style0 from "./Submenu.vue?vue&type=style&index=0&id=16e91700&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  null,
  null
  
)

export default component.exports